import { render, staticRenderFns } from "./ResetPhone.vue?vue&type=template&id=297dd587"
import script from "./ResetPhone.vue?vue&type=script&lang=js"
export * from "./ResetPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports